import React from 'react';

const DeleteModal = ({ onClose, onConfirm }) => {
  return (
    <>
      {/* Backdrop */}
      <div className="modal-backdrop fade show"></div>

      {/* Modal */}
      <div className="modal show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title custom-modal-title fw-bold text-primary font-24">Confirm Delete</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this task?</p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>No</button>
              <button className="btn btn-primary" onClick={onConfirm}>Yes</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteModal;
